import { FavoriteService } from './services/favorite/favorite.service';
import { Component } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { register } from 'swiper/element/bundle';
import { Platform, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { DataService } from './services/data/data.service';
import { AuthService } from './services/auth/auth.service';
// import { DeepLinkService } from './services/deepLink/deep-link.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { CartService } from './services/cart/cart.service';
import { App } from '@capacitor/app';
import { Location } from '@angular/common';
import { FunctionsService } from './services/functions/functions.service';
import { Config, SafeArea } from '@capacitor-community/safe-area';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone:false,
})
export class AppComponent {
  constructor(
    private platform:Platform,
    private storage:Storage,
    private navCtrl:NavController,
    private dataService:DataService,
    private authService:AuthService,
    // private deepLinkService:DeepLinkService,
    private FavoriteService:FavoriteService,
    private cartService:CartService,
    private functionsService:FunctionsService,
    private location:Location,

  ) {
    this.initApp();
  }


  async initApp(): Promise<void> {
    await this.storage.create();
    await this.platform.ready();
    await this.getSettings();
    await this.setSafeArea();
    await this.checkUser();
    await this.cartService.reloadCart();
    await this.FavoriteService.reloadFavorite();
    SplashScreen.hide();
    this.backButton();
  }


  async checkUser() {
    const registration = this.dataService.settings.loginRequired
    let user = await this.storage.get('user');
    // Don't clobber deep links / hard refreshes (e.g. /search from header).
    const path = (this.location.path() || '').split('?')[0];
    const isRoot = !path || path === '/';

    if(user) {
      this.dataService.user = user;
      user = await this.authService.userStatus();
      if(!user.status && registration) return this.navCtrl.navigateRoot('/login')
      // this.deepLink();
      if (isRoot) return this.navCtrl.navigateRoot("/tabs/tab1")
      return;
    }
    this.dataService.privatePrice = false;
    if (registration) return this.navCtrl.navigateRoot('/login')
    if (isRoot) return this.navCtrl.navigateRoot("/tabs/tab1")

    // if(!registration || user?._id) this.deepLink();
  }


  async setSafeArea():Promise<void> {
    if(Capacitor.getPlatform() != 'android') return
    const options:Config = {
      customColorsForSystemBars: false,
      statusBarColor: '#FFFFFF',
      statusBarContent: 'dark',
      navigationBarColor: '#FFFFFF',
      navigationBarContent: 'dark',
    }
    await SafeArea.disable({config:options});
  }


  async deepLink() {
    // this.deepLinkService.listenToDeepLinkOpen();
  }
  // api;
  async getSettings():Promise<void> {
    return new Promise<void>((resolve:any) => {
      this.dataService.getData('/settings')
        .subscribe((res:any) => {
          // Pages capture this object by reference when they are constructed, which on
          // the web happens in parallel with this request (hard refresh / deep link).
          // Merging keeps those references live instead of leaving them on the defaults.
          if(res) Object.assign(this.dataService.settings, res);
          this.cartService.reloadSettings();
          resolve()
        },err => {
          resolve();
        })
    })
  }


  async backButton():Promise<void | boolean> {
    const pages = ["/tabs/tab1","/tabs/tab2","/tabs/tab3","/tabs/tab4","/tabs/tab5"]

    App.addListener("backButton", async ()=> {
      const path = this.location.path()
      if(pages.includes(path) && path != pages[0]) return await this.navCtrl.navigateForward(pages[0])

      const routers = ['/login',"/tabs/tab1"]
      if(routers.includes(path)) {
        if(confirm("هل تريد الخروج من التطبيق ؟")) return App.exitApp()
      }

    })
  }

}
